import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const ResetPassword = Loadable({
  loader: () => import('./containers/ResetPasswordContainer'),
  loading: Loading,
})

export default {
  path: '/reset-password',
  component: ResetPassword,
}



// WEBPACK FOOTER //
// ./src/routes/resetPassword/index.js